<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('INDEX.header_search_placeholder_order_batch') ||
                  '交货批次号/批次识别单号/零售商PO/代理商PO/收货人 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('exportData')"
            >
              <i class="el-icon-download"></i
              >{{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :visible.sync="advqueryDialogVisible"
        width="1000px"
        show-close
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :modal="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="130px"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_orderBatchNo') ||
                    '交货批次号'
                "
              >
                <el-input v-model.trim="form.orderBatchNo" clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_identifyNo') || '批次识别单号'"
              >
                <el-input v-model.trim="form.identifyNo" clearable> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="'零售商PO'">
                <el-input v-model.trim="form.retailerPo" clearable> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="'代理商PO'">
                <el-input v-model.trim="form.importerPo" clearable> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_receiver') || '收货人'"
              >
                <el-input v-model.trim="form.receiver" clearable> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_deliveryType') || '出货方式'"
              >
                <dict-select
                  v-model="form.listDeliveryType"
                  url="/master/common/dict/biz"
                  :body="deliveryTypeParams"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="small"
                  multiple
                  filterable
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_outBillType') || '出单类型'"
              >
                <dict-select
                  v-model="form.listOutBillType"
                  url="/master/common/dict/biz"
                  :body="outBillTypeParams"
                  size="small"
                  multiple
                  filterable
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_dispatchPort') || '发运港口'"
              >
                <dict-select
                  v-model="form.listDispatchPort"
                  url="/master/port/select"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="small"
                  multiple
                  filterable
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_destinationPort') || '目的港口'"
              >
                <dict-select
                  v-model="form.listDestinationPort"
                  url="/master/port/select"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="small"
                  multiple
                  filterable
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_deliveryDate') || '出货日期'"
              >
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.deliveryDateStart"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.deliveryDateEnd"
                      type="date"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">
            {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
          </el-button>
          <el-button size="small" type="warning" @click="reload">
            {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
          </el-button>
          <el-button size="small" type="primary" @click="advquery">
            {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
          </el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      deliveryTypeParams: { dictType: 'deliveryType' },
      outBillTypeParams: { dictType: 'outBillType' },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
